import React, { Fragment, useState } from "react";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import * as Yup from "yup";

import Button from "../../components/button";

const SendNotificationForm = props => {

  const [doctorData, setDoctorData] = useState(props.doctorData ? props.doctorData : null);

  const formik = useFormik({
    initialValues: {
      message: ""
    },
    validationSchema: Yup.object({
      message: Yup.string()
        .required("Please enter the message")
        .min(2, "Message must be of atleat 2 characters")
    }),
    onSubmit: values => {
      props.onFormSubmit(values.message);
    }
  });

  const [value, setValue] = React.useState("");
  const [preFilledValues, setPreFilledValues] = React.useState({
    "Yellow 1":
      "We are reviewing recent consult requests and noticed you have requested a consult but were unable to connect with a doctor. We currently do not have any doctors online. Please cancel your request. We will notify you as soon as one comes available. You can also see if doctors are online by checking your dashboard/homepage on the Instant Consult app. Any queries, please do not hesitate to contact us.",
    "Yellow 2A":
      "There are now doctors online and available to accept your consult request. You can also see if doctors are online by checking your dashboard/homepage on the Instant Consult app. Any queries, or if you still cannot connect with a doctor, please do not hesitate to contact us.",
    "Yellow 2B":
      "There are now multiple doctors online and available to accept your consult request. We do apologise for the wait earlier; you will now be connected promptly. Any queries, or if you still cannot connect with a doctor, please do not hesitate to contact us.",
    "Yellow 4":
      "We are reviewing recent consult requests and noticed you have requested a consult but were unable to connect with a doctor. We do have doctors online and available to accept your consult request, so it may be a device or connection issue. Please contact us so we can assist you in connecting with a doctor promptly.",
    'Blue Attempt': `We have attempted to contact you regarding your prescription issued by Dr <Name Surname>.\n\nPlease call us on 1300 003 310 so we can organise your prescription to be sent to your local pharmacy for immediate collection. Thank you.`,
    Blue:
      `You can collect your prescription from: \n<Pharmacy Name> \n<Pharmacy Address>`
  });

  const [preFilledDoctorValues, setPreFilledDoctorValues] = React.useState({
    "Specialist Letter":
      "Specialist letter for patient UIN: XXXXXX has been received and is available to view in patients records. FYI only - no action required.",
    "Blue":
      `Hi Dr ${doctorData ? (doctorData.fullName.split(" ")[0]) : "XXXXXX"}. We have sent you an important email. Please check this when you have a moment. Thank you.`,
  })

  const handleChange = event => {
    setValue(event.target.value);
    formik.values.message = preFilledValues[event.target.value]
      ? preFilledValues[event.target.value]
      : "";
  };

  const handleChangeDoctor = event => {
    setValue(event.target.value);
    formik.values.message = preFilledDoctorValues[event.target.value]
      ? preFilledDoctorValues[event.target.value]
      : "";
  };

  return (
    <Fragment>
      <p>
        Message <span className="error">*</span>
      </p>
      <RadioGroup
        row
        aria-label="position"
        name="position"
        className={props.isPatient ? '': 'd-none'}
        // defaultValue={value}
        onChange={handleChange}
      >
        <FormControlLabel
          className="col-sm-4 p-0 m-0"
          value="Yellow 1"
          control={<Radio color="primary" />}
          label="Yellow 1"
        />
        <FormControlLabel
          className="col-sm-4 p-0 m-0"
          value="Yellow 2A"
          control={<Radio color="primary" />}
          label="Yellow 2A"
        />
        <FormControlLabel
          className="col-sm-4 p-0 m-0"
          value="Yellow 2B"
          control={<Radio color="primary" />}
          label="Yellow 2B"
        />
        <FormControlLabel
          className="col-sm-4 p-0 m-0"
          value="Yellow 4"
          control={<Radio color="primary" />}
          label="Yellow 4"
        />
         <FormControlLabel
          className="col-sm-4 p-0 m-0"
          value="Blue Attempt"
          control={<Radio color="primary" />}
          label="Blue Attempt"
        />
        <FormControlLabel
          className="col-sm-4 p-0 m-0"
          value="Blue"
          control={<Radio color="primary" />}
          label="Blue"
        />
      </RadioGroup>

      <RadioGroup
        row
        aria-label="position"
        name="position"
        className={props.isDoctor ? '': 'd-none'}
        // defaultValue={value}
        onChange={handleChangeDoctor}
      >
        <FormControlLabel
          className="col-sm-4 p-0 m-0"
          value="Specialist Letter"
          control={<Radio color="primary" />}
          label="Specialist Letter"
        />
        <FormControlLabel
          className="col-sm-4 p-0 m-0"
          value="Blue"
          control={<Radio color="primary" />}
          label="Blue"
        />
      </RadioGroup>
      <form className="d-flex flex-column" onSubmit={formik.handleSubmit}>
        <TextField
          name="message"
          className="w-100"
          rows={'10'}
          multiline
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.message}
          error={formik.touched.message && formik.errors.message ? true : false}
          helperText={
            formik.touched.message && formik.errors.message
              ? formik.errors.message
              : ""
          }
        />
        <br />
        <p className="mb-0 d-flex justify-content-center">
          <Button title="Submit" type="submit" />
        </p>
      </form>
    </Fragment>
  );
};

export default SendNotificationForm;

SendNotificationForm.propTypes = {
  onFormSubmit: PropTypes.func.isRequired
};
